export default [
    {
        id: 'en',
        description: 'English',
        lang: 'en',
    },
    {
        id: 'ar',
        description: 'العربية',
        lang: 'ar',
    },
    {
        id: 'id',
        description: 'Bahasa Indonesia',
        lang: 'id',
    },
    {
        id: 'zh',
        description: '漢語',
        lang: 'zh',
    },
    {
        id: 'zh_CN',
        description: '汉语',
        lang: 'zh-CN',
    },
    {
        id: 'da',
        description: 'Dansk',
        lang: 'da',
    },
    {
        id: 'de',
        description: 'Deutsch',
        lang: 'de',
    },
    {
        id: 'es',
        description: 'Español',
        lang: 'es',
    },
    {
        id: 'fr',
        description: 'Français',
        lang: 'fr',
    },
    {
        id: 'el',
        description: 'Ελληνικά',
        lang: 'el',
    },
    {
        id: 'hi',
        description: 'हिन्दी',
        lang: 'hi',
    },
    {
        id: 'it',
        description: 'Italiano',
        lang: 'it',
    },
    {
        id: 'ja',
        description: '日本語',
        lang: 'ja',
    },
    {
        id: 'ko',
        description: '한국어',
        lang: 'ko',
    },
    {
        id: 'nl',
        description: 'Nederlands',
        lang: 'nl',
    },
    {
        id: 'no',
        description: 'Norsk',
        lang: 'no',
    },
    {
        id: 'pl',
        description: 'Polski',
        lang: 'pl',
    },
    {
        id: 'pt',
        description: 'Português',
        lang: 'pt',
    },
    {
        id: 'pt_BR',
        description: 'Português (Brasil)',
        lang: 'pt-BR',
    },
    {
        id: 'ru',
        description: 'Pусский',
        lang: 'ru',
    },
    {
        id: 'ro',
        description: 'Română',
        lang: 'ro',
    },
    {
        id: 'fi',
        description: 'Suomi',
        lang: 'fi',
    },
    {
        id: 'sv',
        description: 'Svenska',
        lang: 'sv',
    },
    {
        id: 'th',
        description: 'ภาษาไทย',
        lang: 'th',
    },
    {
        id: 'vi',
        description: 'Tiếng Việt',
        lang: 'vi',
    },
    {
        id: 'tr',
        description: 'Türkçe',
        lang: 'tr',
    },
];



// WEBPACK FOOTER //
// ./src/components/Form/langFieldOptions.js